import { getData } from '../../../get-table'
import { HttpService } from '../../../http.service'

const http = new HttpService()

export async function getLoans(
    payrollIds: string,
    endDate: string,
    loanTypes: string,
    employees: string,
    startDate?: string,
  ) {
    const data = await getData<any>(
      {
        tables: ['pg_loans'],
        fields: [
          'loans.id as id',
          'loans.employee_id as employeeId',
          'loans.amount',
          'loans.currency_id as currencyId',
          'loans.concept_id as conceptId',
          'loans.quota_amount as quotaAmount',
          'loans.start_date as startDate',
          'loans.end_date as endDate',
          'loans.is_loan_paid as isLoanPaid',
          'loans.is_inactive as isInactive',
          'loans.loan_type_id as loanTypeId',
          'loans.balance as balance',
          'loan_types.code as codeLoanType'
        ],
        where: [
          `loans.payroll_id IN (${payrollIds})`,
          `loans.employee_id IN (${employees})`,
          `loans.start_date <= '${endDate}'`,
          `loans.is_inactive = false`,
          `employees.leave_date is null`,
          `loans.loan_type_id IN (${loanTypes})`
        ],
        join: [
          'INNER JOIN employees ON employees.id = loans.employee_id',
          'INNER JOIN loan_types ON loan_types.id = loans.loan_type_id'
        ]
      },
    )

    let _employees: any = []
    for (const loans of data[0].results) {
      _employees.push(loans.employeeId)
    }
    return _employees
}
export async function getLoansTypes(codes: any = '') {
  const where = ['is_deleted = false']
  if (codes !== '') where.push(`code IN (${codes})`)
  const data = await getData<any>({
    tables: ['pg_loan_types'],
    fields: ['id'],
    where,
    modifier: ['order by name asc']
  })

  return data[0].results
}

export async function getEmployeesLoans(employeesIds: string) {
  const where = [
    `employees.id IN (${employeesIds})`,
    'employee_accounts.is_active_account=true'
  ]

  const data = await getData<any>({
    tables: ['pg_employee_accounts'],
    fields: [
      'employees.id',
      'employees.name',
      'directions.name as direccion',
      'managements.name as gerencia',
      'departments.name as departamento',
      'sucursals.name as sucursal',
      'positions.name as cargo',
      'turns.name as turno',
      'employees.leave_date as fechaSalida',
      'employees.code as codigo',
      'joining_reasons.name as causaIngreso',
      "CONCAT(employees.code,' - ',employees.name) as codigo_name",
      "STRING_AGG(banks.id::text, ', ') as bankId",
      'false as isChecked'
    ],
    join: [
      'INNER JOIN employees ON employee_accounts.employee_id = employees.id',
      'INNER JOIN banks ON employee_accounts.bank_id = banks.id',
      'LEFT JOIN directions ON employees.direction_id = directions.id',
      'LEFT JOIN managements ON employees.management_id = managements.id',
      'LEFT JOIN departments ON employees.department_id = departments.id',
      'LEFT JOIN sucursals ON employees.sucursal_id = sucursals.id',
      'LEFT JOIN positions ON employees.position_id = positions.id',
      'LEFT JOIN turns ON employees.turn_id = turns.id',
      'LEFT JOIN joining_reasons ON employees.joining_reason_id = joining_reasons.id'
    ],
    where,
    modifier: [
      'group by employees.id,employees.name, employees.leave_date, employees.code,directions.name,managements.name,sucursals.name,departments.name,positions.name,turns.name,joining_reasons.name',
      'order by employees.name asc'
    ]
  })

  return data[0].results
}

export function reduceEmployees(employees: Array<[]>) {
  let uniqueEmployees: any = []
  employees.reduce((res: any, value: any) => {
    if (!res[value]) {
      res[value] = value
      uniqueEmployees.push(value)
    }
    return res
  }, {})

  return uniqueEmployees
}